import { motion } from "framer-motion";
import { PRINCIPLES } from "@/lib/content";
import { fadeUp, stagger, maskLine } from "@/lib/motion";

export default function Philosophy() {
  const QUOTE = [
    "\"A successful space must be designed",
    "thoughtfully, developed responsibly and built",
    "around the people who will experience it.\"",
  ];
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative bg-ink-900/40 py-32 md:py-48 border-y border-ivory/[0.06] overflow-hidden"
    >
      {/* faint grid backdrop */}
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="max-w-[1600px] mx-auto h-full px-6 sm:px-10 lg:px-16 hidden md:grid grid-cols-12">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className="border-l border-ivory/[0.04] h-full" />
          ))}
        </div>
      </div>

      <div className="relative max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="font-mono-caps text-[10px] text-copper mb-10">
          <span className="mr-3">§ 06</span> Philosophy
        </div>

        <motion.blockquote
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="font-serif italic text-ivory text-3xl sm:text-5xl lg:text-7xl leading-[1.08] tracking-tight max-w-[22ch]"
        >
          {QUOTE.map((line, i) => (
            <span key={i} className="mask-line block">
              <motion.span variants={maskLine} custom={i}>
                {line}
              </motion.span>
            </span>
          ))}
        </motion.blockquote>

        <div className="mt-14 flex items-center gap-4 text-copper">
          <span className="h-px w-12 bg-copper" />
          <span className="font-mono-caps text-[10px]">Parin Majithia</span>
        </div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          variants={stagger}
          className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-4 gap-6"
        >
          {PRINCIPLES.map((p) => (
            <motion.div
              key={p.k}
              variants={fadeUp}
              data-testid={`principle-${p.k}`}
              className="group border-l border-ivory/[0.12] pl-6 py-2 hover:border-copper transition-colors"
            >
              <div className="font-mono text-copper text-xs mb-4">{p.k}</div>
              <h3 className="font-serif text-2xl text-ivory leading-tight">{p.t}</h3>
              <p className="mt-3 text-ivory/60 text-sm leading-relaxed">{p.d}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
